import React, { Component } from "react";
import { Layout, Menu, } from "antd";
import { connect } from "react-redux";
import { router, system, Icon } from "@/nano";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import { getSidebarCollapsed, setSidebarCollapsed } from "@/utils/storage";

import "./index.less";

let menuMap = {};

function getMenuItems(items, perItem) {
  return items.filter(item => !item.hidden).map(item => {
    const { title, icon } = item.meta || {};
    const menuItem = {
      label: title,
      icon: <Icon value={icon} />,
      key: 0 === item.path.indexOf("/") ? item.path : `${perItem.path}/${item.path}`,
    };
    menuMap[menuItem.key] = { ...menuItem, perKey: perItem ? perItem.path : null, };
    menuItem.children = item.children && item.children.length ? getMenuItems(item.children, item) : null;
    return menuItem;
  });
}

function getDefaultOpenKeys(key, keys) {
  const menuItem = menuMap[key]
  if (menuItem.perKey) {
    getDefaultOpenKeys(menuItem.perKey, keys)
  }
  keys.push(menuItem.key)
}

class Sidebar extends Component {
  state = {
    bottomItems: [],
    collapsed: getSidebarCollapsed(),
  };

  componentDidMount() {
    this.onToggleCollapsed(this.state.collapsed);
  }

  getItemCollapsed = (collapsed) => {
    if (collapsed) {
      return {
        label: "展开",
        key: "shrink",
        icon: <MenuUnfoldOutlined />,
      }
    }
    return {
      label: "收起",
      key: "collapsed",
      icon: <MenuFoldOutlined />,
    };
  };

  getMenuItems = () => {
    menuMap = {};
    return getMenuItems(this.props.menuList);
  };

  getRouteKey = () => {
    return window.location.pathname;
  };

  getDefaultSelectedKeys = (items) => {
    const key = this.getRouteKey();
    const menuItem = menuMap[key];
    return menuItem ? [menuItem.key] : [];
  };

  getDefaultOpenKeys = (defaultSelectedKeys) => {
    const keys = [];
    if (defaultSelectedKeys.length) {
      getDefaultOpenKeys(defaultSelectedKeys[0], keys);
    }
    return keys;
  };

  onMenuClick = (e) => {
    let { key: path } = e;
    const root = system.getSystemReleasePath("");
    if (path.startsWith(root)) {
      path = path.substring(root.length)
    }
    router.history.push(path);
  };

  onBottomClick = (e) => {
    if (["shrink", "collapsed"].includes(e.key)) {
      this.onToggleCollapsed("collapsed" === e.key);
    }
  };

  onToggleCollapsed = (collapsed) => {
    const { bottomItems = [], } = this.state;
    this.setState({
      ...this.state,
      collapsed,
      bottomItems: [
        ...bottomItems.slice(0, bottomItems.length - 1),
        this.getItemCollapsed(collapsed),
      ],
    }, () => {
      setSidebarCollapsed(collapsed)
    });
  };

  render() {
    if (!this.props.menuList) {
      return (<></>)
    }
    const menuItems = this.getMenuItems();
    const defaultSelectedKeys = this.getDefaultSelectedKeys(menuItems);
    const defaultOpenKeys = this.getDefaultOpenKeys(defaultSelectedKeys);
    return (
      <Layout.Sider
        className="nano-layout-sider"
        trigger={null}
        collapsible
        collapsedWidth={56}
        style={{ overflow: "auto" }}
        collapsed={this.state.collapsed}
      >
        <div className="nano-layout-sider-box">
          <div className="nano-layout-sider-top">
            <Menu
              theme="dark"
              mode="inline"
              items={menuItems}
              onClick={this.onMenuClick}
              defaultOpenKeys={defaultOpenKeys}
              defaultSelectedKeys={defaultSelectedKeys}
            />
          </div>
          <div className="nano-layout-sider-bottom">
            <Menu
              theme="dark"
              mode="inline"
              items={this.state.bottomItems}
              onClick={this.onBottomClick}
            />
          </div>
        </div>
      </Layout.Sider>
    );
  };
}


export default connect((state) => {
  return {
    menuList: state.resource.menuList
  };
})(Sidebar);
